var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 928,
    height: 700,
    viewBox: "0 0 928 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox ikonka 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M447.9 703.1C448.1 702.9 458 692.7 469.8 680.5L479.8 670.2C491.6 658 511 638.1 522.8 625.9L762.5 378.7C774.3 366.5 774 346.9 761.8 335L750.6 324.1C738.4 312.3 718.8 312.6 706.9 324.8L467.3 572C455.5 584.2 435.8 584.5 423.6 572.7L316.7 469C304.5 457.2 284.9 457.5 273 469.7L262.1 480.9C250.3 493.1 250.6 512.7 262.8 524.6L425.3 682.2C437.5 693.9 447.7 703.4 447.9 703.1Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxAccept);
export default __webpack_public_path__ + "static/media/checkboxAccept.45d02bf84ef77decf07a9e468ba7506e.svg";
export { ForwardRef as ReactComponent };